// extracted by mini-css-extract-plugin
export var askAiIcon = "_r6-9";
export var container = "_r6-0";
export var groupSeparator = "_r6-a";
export var highlight = "_r6-4";
export var resultIcon = "_r6-5";
export var resultItem = "_r6-7";
export var resultSubtitle = "_r6-3";
export var resultTitle = "_r6-2";
export var resultsList = "_r6-1";
export var searchGroup = "_r6-6";
export var selected = "_r6-8";